import * as React from 'react';
import { SVGProps } from 'react';

const IconLineAndBarChartSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m8.315 1 2.452 2.784L10 4.5 8.275 2.555 6.04 4.876 3.686 3.248 2 4.5l-.66-.823 2.278-1.763 2.29 1.584L8.315 1Z"
    />
    <path d="M4.5 6h1v5h-1V6ZM2.5 8h1v3h-1V8ZM7.5 7h-1v4h1V7ZM8.5 6h1v5h-1V6Z" />
  </svg>
);
export default IconLineAndBarChartSizeXs;
